export default { release:'25.10.0.1' }
